import { configureStore } from "@reduxjs/toolkit";
import { searchReducer } from "./search";
import { articleSelectorReducer } from "./export";
import { reports43101Reducer } from "./reports43101";

export default configureStore({
  reducer: {
    searchSlice: searchReducer,
    selectSlice: articleSelectorReducer,
    reports43101Slice: reports43101Reducer,
  },
});
